import { render } from "./tours.vue?vue&type=template&id=de2f9e1a"
import script from "./tours.vue?vue&type=script&lang=js"
export * from "./tours.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__